import { AddRequest } from '@/types';

export const demoRequests: AddRequest[] = [
  // {
  //   id: 'req1',
  //   requesterName: 'فهد العمري',
  //   childName: 'سلطان',
  //   phoneNumber: '0502222222',
  //   status: 'pending',
  //   timestamp: Date.now() - 43200000, // 12 hours ago
  //   parentId: 'child1'
  // },
  // {
  //   id: 'req2',
  //   requesterName: 'سعد العمري',
  //   childName: 'ريان',
  //   phoneNumber: '0503333333',
  //   status: 'pending',
  //   timestamp: Date.now() - 21600000, // 6 hours ago
  //   parentId: 'child2'
  // }
];